// src/core/api/demoRequestsApi.js
import { axiosClient } from "./axiosClient";

export const demoRequestsApi = {
  list: async () => {
    const res = await axiosClient.get("/book-demo/");
    return res.data;
  },

  detail: async (id) => {
    const res = await axiosClient.get(`/book-demo/${id}/`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await axiosClient.patch(`/book-demo/${id}/`, payload);
    return res.data;
  },

  remove: async (id) => {
    await axiosClient.delete(`/book-demo/${id}/`);
  },
};
